import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export async function updateClient(client) {
    const response = await axios.put(`${CLIENTES_ENDPOINT}/${client.id}`, client)
    return response?.data?.data
}
